import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { FaSave } from "react-icons/fa";
import { MdArrowBack, MdArrowForward } from "react-icons/md";

import {
    CulturalIcon,
    CarreraIcon,
    InteresIcon,
    LiderazgoIcon,
} from "../../../../Icons/Icons";
import {
    btnTranslate,
    climeCultureTranslate,
    modalAssignTranslate,
} from "../../../../i18n/translatedMessages";

import { calculateCulture as CalculateCulture } from "../../../../API/Candidates/Culture";
import { patchCandidateCulture } from "../../../../API/Candidates/Culture";

import { askesPT, askesES } from "./askes";
import AskBox from "./AskBox";

import "./quiz.sass";

const Quiz = () => {
    const lang = useIntl();
    const askes = lang.locale === "PT-BR" ? askesPT : askesES;

    const [type, setType] = useState("cultural");
    const [list, setList] = useState(null);
    const [btnCondition, setBtnCondition] = useState(false);

    const answerEmpty = {
        cultural: {
            me: [null, null, null, null, null, null],
            industry: [null, null, null, null, null, null],
        },
        carrera: {
            me: [null, null, null, null, null, null],
            industry: [null, null, null, null, null],
        },
        liderazgo: {
            me: [null, null, null, null, null, null],
            industry: [null, null, null, null, null],
        },
        interese: {
            me: [null, null, null, null, null, null],
            industry: [null, null, null, null, null],
        },
    };
    const [answer, setAnswer] = useState(answerEmpty);

    useEffect(() => {
        const filtCarreraMe = answer.carrera.me;
        const filtCulturalMe = answer.cultural.me;
        const filtLiderazgoMe = answer.liderazgo.me;
        const filtIntereseMe = answer.interese.me;
        const answers = [
            ...filtCarreraMe,
            ...filtCulturalMe,
            ...filtLiderazgoMe,
            ...filtIntereseMe,
        ];
        const filtAnswers = answers.filter((x) => {
            return x === null;
        });
        if (filtAnswers.length === 0) {
            setBtnCondition(true);
        } else {
            setBtnCondition(false);
        }
    }, [answer, btnCondition]);

    useEffect(() => {
        const array = askes.filter((item) => item.type === type);
        setList(
            array.map((item, index) => ({
                ...item,
                id: index,
            }))
        );
    }, [type, lang.locale]);

    const handleUser = (toggle, id) => {
        const array = { ...answer };
        array[type].me.splice(id, 1, toggle);

        setAnswer(array);
    };

    const handleSend = async () => {
        const array = [
            [...answer.cultural.me],
            [...answer.carrera.me],
            [...answer.liderazgo.me],
            [...answer.interese.me],
        ];

        const calculateCulture = await CalculateCulture(array);

        if (calculateCulture) {
            const candidateCulture = {
                commercial_percentage:
                    calculateCulture.comercial.toFixed(2).toString() + "%",
                disruptive_percentage:
                    calculateCulture.disruptiva.toFixed(2).toString() + "%",
                traditional_percentage:
                    calculateCulture.tradicional.toFixed(2).toString() + "%",
                collaborative_percentage:
                    calculateCulture.colaborativa.toFixed(2).toString() + "%",
            };

            await patchCandidateCulture(
                localStorage.getItem("candidateId"),
                candidateCulture
            );
        }
        window.location.reload();
    };

    const handleNext = () => {
        if (type === "cultural") {
            setType("carrera");
        } else if (type === "carrera") {
            setType("liderazgo");
        } else if (type === "liderazgo") {
            setType("interese");
        } else if (type === "interese") {
            setType("cultural");
        }
    };

    const handleBack = () => {
        if (type === "cultural") {
            setType("interese");
        } else if (type === "interese") {
            setType("liderazgo");
        } else if (type === "liderazgo") {
            setType("carrera");
        } else if (type === "carrera") {
            setType("cultural");
        }
    };

    return (
        <div className="quiz-b2e">
            <div className="row mt-5 buttons">
                <div className="col-md-6 col-lg-6 col-xl-3">
                    <button
                        className={`pills-b2e ${
                            type === "cultural" ? "active" : ""
                        }`}
                        onClick={() => setType("cultural")}
                        disabled={answer["cultural"]["me"].some(
                            (item) => item === null
                        )}
                    >
                        <CulturalIcon
                            size={20}
                            color={type === "cultural" ? "#FAFAFA" : "#746be8"}
                        />
                        {climeCultureTranslate.questionCulture}
                    </button>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3">
                    <button
                        className={`pills-b2e ${
                            type === "carrera" ? "active" : ""
                        }`}
                        onClick={() => setType("carrera")}
                        disabled={answer["carrera"]["me"].some(
                            (item) => item === null
                        )}
                    >
                        <CarreraIcon
                            size={20}
                            color={type === "carrera" ? "#FAFAFA" : "#746be8"}
                        />
                        {climeCultureTranslate.questionCarrer}
                    </button>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3">
                    <button
                        className={`pills-b2e ${
                            type === "liderazgo" ? "active" : ""
                        }`}
                        onClick={() => setType("liderazgo")}
                        disabled={answer["liderazgo"]["me"].some(
                            (item) => item === null
                        )}
                    >
                        <LiderazgoIcon
                            size={20}
                            color={type === "liderazgo" ? "#FAFAFA" : "#746be8"}
                        />
                        {climeCultureTranslate.questionLeader}
                    </button>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3">
                    <button
                        className={`pills-b2e ${
                            type === "interese" ? "active" : ""
                        }`}
                        onClick={() => setType("interese")}
                        disabled={answer["interese"]["me"].some(
                            (item) => item === null
                        )}
                    >
                        <InteresIcon
                            size={20}
                            color={type === "interese" ? "#FAFAFA" : "#746be8"}
                        />
                        {climeCultureTranslate.questionInterests}
                    </button>
                </div>
            </div>
            <div className="row d-flex mt-2">
                {list &&
                    list.map((item, index) => (
                        <div
                            key={index}
                            className="col-md-12 col-lg-12 col-xl-6 my-3"
                        >
                            <AskBox
                                ask={item}
                                me={answer[type]?.me[item.id]}
                                industry={answer[type]?.industry[item.id]}
                                handleUser={handleUser}
                            />
                        </div>
                    ))}
            </div>
            <div className="row align-items-center">
                <div className="col">
                    <button
                        className="button-navigate mt-3"
                        onClick={handleBack}
                        disabled={type === "cultural"}
                    >
                        <MdArrowBack size={20} />
                        Volver
                    </button>
                </div>
                <div className="col d-flex justify-content-end">
                    {btnCondition ? (
                        <button
                            className="btn-save-answer mt-3"
                            onClick={handleSend}
                        >
                            <FaSave size="18" />
                            <span className="fs-5 ms-3">
                                {modalAssignTranslate.btnSave}
                            </span>
                        </button>
                    ) : (
                        type !== "interese" && (
                            <button
                                className="button-navigate px-0 mt-3"
                                onClick={handleNext}
                                disabled={answer[type]["me"].some(
                                    (item) => item === null
                                )}
                            >
                                <span className="">
                                    {btnTranslate.nextButton}
                                </span>
                                <MdArrowForward />
                            </button>
                        )
                    )}
                </div>
            </div>
        </div>
    );
};
export default Quiz;
